import React from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import './scss/style.scss'
import 'react-toastify/dist/ReactToastify.css'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheLayout = React.lazy(() => import('./containers/TheLayout'))
const Login = React.lazy(() => import('./views/Usuarios/Login'))

const getSessionUser = () => {
  const rawUser = localStorage.getItem('usuarioensesion')

  if (!rawUser) {
    return null
  }

  try {
    const parsedUser = JSON.parse(rawUser)
    return Array.isArray(parsedUser) && parsedUser.length > 0 ? parsedUser : null
  } catch (error) {
    console.log(`App: error parseando usuarioensesion: ${JSON.stringify(error)}`)
    return null
  }
}

const App = () => {
  const userSession = getSessionUser()

  return (
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          {userSession ? (
            <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
          ) : (
            <Route path="/" name="Login Page" render={props => <Login {...props} />} />
          )}
        </Switch>
      </React.Suspense>
    </HashRouter>
  )
}

export default App
